export default __webpack_public_path__ + "static/media/faz_3.f6edcdeb.png";